import 'babel-polyfill';

import React from 'react'
import ReactDOM from 'react-dom'
import 'normalize.css/normalize.css'
import './index.css'
import './buttonCreate.css'
import App from './App'
import { positions, Provider } from "react-alert";
import { Provider as StoreProvider } from 'react-redux';
import { store } from './store/create'
import AlertTemplate from "react-alert-template-basic";
import initAnalytics from './analytics';
import { loginCode } from './service/lex/main';
import { setRedirectLoading } from './store/action_creators/loading';
const alert_options = {
  timeout: 5000,
  position: positions.BOTTOM_RIGHT
};

// Функция для проверки и обработки авторизационного кода при запуске приложения
const checkAuthCode = () => {
  // Сначала проверяем, что мы на нужной странице диагностики
  const isPrerunTestPage = window.location.pathname === '/diagnostics/prerun-test-irtech' || 
                          window.location.pathname === '/diagnostics/prerun-test-irtech/' ||
                          window.location.pathname === '/diagnostics' ||
                          window.location.pathname === '/diagnostics/' ||
                          window.location.pathname === '/irtech/' ||
                          window.location.pathname === '/irtech' ||
                          window.location.pathname.includes('/irtech-monitoring/');
  // Если мы на странице prerun-test-irtech, то проверяем наличие кода в URL
  if (isPrerunTestPage) {
    // Извлекаем параметры из URL
    const urlParams = new URLSearchParams(window.location.search);
    // Получаем значение параметра 'code'
    const code = urlParams.get('code');
    
    // Если код найден в URL
    if (code) {
      console.log('!!!! Обнаружен авторизационный код на странице prerun-test-irtech:', code);
      // Отправляем код в Redux action для обработки
      store.dispatch(setRedirectLoading(true));
      store.dispatch(loginCode(code, window.location));
    } else {
      store.dispatch(setRedirectLoading(false));
      // Если код не найден, логируем это
      console.log('!!!! На странице prerun-test-irtech не найден код авторизации');
    }
  } else {
    store.dispatch(setRedirectLoading(false));
    // Если мы не на нужной странице, пропускаем проверку
    console.log('!!!! Мы не на странице prerun-test-irtech, пропускаем проверку кода');
    console.log('Текущий путь:', window.location.pathname);
  }
};

// Выполняем проверку кода до рендера компонентов
checkAuthCode();

initAnalytics();
ReactDOM.render(
  <StoreProvider store={store}>
    <Provider template={AlertTemplate} {...alert_options}>
      <App />
    </Provider>
  </StoreProvider>, 
  document.getElementById('root'))

